import { useState, useEffect } from "react";
import { fetchReports } from "../services/fetchReports";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadReports = async () => {
      try {
        const topic =
          breadcrumbs.find((item) => item.path === "/subtopics")?.id || null;

        const data = await fetchReports(auth.token, topic);
        // console.log("Fetched Reports Data:", data.data.data);

        if (data.status === 200) {
          const fnl_data = data.data.data;
          const formatted = fnl_data.map((report) => ({
            id: report.id,
            name: report?.title,
            mark: report.percent ?? 0,
            questions_report: report.questions_report
          }));
          // console.log("formatted", formatted);
          setReports(formatted);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
      } catch (err) {
        console.error("Error fetching reports:", err);
        setError(err.message || "Failed to fetch reports");
      } finally {
        setLoading(false);
      }
    };

    loadReports();
  }, [auth, breadcrumbs, setCommonWarning]);

  return { reports, loading, error };
}

export default useFetchReports;
